import Api from "~/service/Api";

class AwsS3MultipartUploadRepository {
  create(data) {
    return Api.post("/aws-s3/multipart-uploads", data);
  }

  update(data) {
    return Api.put("/aws-s3/multipart-uploads", data);
  }

  delete(uploadId, key) {
    return Api.delete(`/aws-s3/multipart-uploads/${uploadId}/${key}`);
  }
}

export default AwsS3MultipartUploadRepository;
